import React from 'react';
import { Button, Dimmer, Grid, Loader, Table, Modal, Dropdown, TextArea, Icon } from 'semantic-ui-react';
import PropTypes from "prop-types";
import DataProvider from "./data-providers/data-provider";
import ExportDataProvider from "./data-providers/export-data-provider";
import CsvExportDataProvider from "./data-providers/csv-export-data-provider";
import { Observable } from "rxjs";
import * as api from '../../api'
import { toast } from 'react-toastify';

function Header() { return null }
function Footer() { return null }

export default class EnvironmentCommentaryDataTable extends React.Component {

    static Header = Header;
    static Footer = Footer;

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            isLoading: false,
            dataProvider: this.props.dataProvider,
            exportDataProvider: this.props.exportDataProvider || new CsvExportDataProvider(),
            sortSettings: {
                sort: this.props.defaultSort || '',
                order: "desc",
            },


            open: false,
            period: "",
            currentYear: new Date().getFullYear(),
            year:new Date().getFullYear() ,
            utility: "",
            comments: "",
            isPeriodHasError: false,
            isUtilityHasError: false,
            isCommentsHasError: false,

            commitSuccess: false
        };
    }

    componentDidMount() {
        this.refreshData();
    }

    componentDidUpdate() {
        if (this.state.commitSuccess) {

            this.refreshData();
            this.setState({
                commitSuccess: false
            });

        }

    }

    get getDataProviderContext() {
        const defaultContext = {
            sortSettings: this.state.sortSettings,
            name: this.props.name
        };

        if (!this.props.additionalProviderContext) { return defaultContext; }

        return { ...defaultContext, ...this.props.additionalProviderContext() };
    }

    getSlot(slotType) {
        const children = this.props.children || {};
        if (children.find) { return children.find(child => child.type === slotType); }
        return children.type === slotType ? children : null;
    }

    get headerSlot() { return this.getSlot(Header); }
    get footerSlot() { return this.getSlot(Footer); }

    get showExport() {
        return this.props.headerComponent.Layout && (typeof (this.props.canExport) === "undefined") ? true : this.props.canExport
    }

    UNSAFE_componentWillMount() {
        if (this.props.refreshDataTrigger) { this.props.refreshDataTrigger.subscribe(this.refreshData); }
    }

    componentWillUnmount() {
        if (this.props.refreshDataTrigger && this.props.refreshDataTrigger.unsubscribe) { this.props.refreshDataTrigger.unsubscribe(this.refreshData); }
    }

    onChangeSort = clickedColumn => {
        const { sort, order } = this.state.sortSettings;

        let newOrder = order === 'asc' ? 'desc' : 'asc';
        if (sort !== clickedColumn) {
            newOrder = 'asc';
        }

        const sortSettings = { sort: clickedColumn, order: newOrder };
        this.setState({ sortSettings }, this.refreshData);
    };

    refreshData = () => {
        const loadingTimeout = setTimeout(() => {
            this.setState({ isLoading: true });
        }, 500);

        return this.state.dataProvider
            .refreshData(this.getDataProviderContext)
            .then((data) => {
                clearTimeout(loadingTimeout);
                this.setState({ data: data.elements, isLoading: false });
                if (this.props.onTableRefreshed) { this.props.onTableRefreshed(data); }
            });
    };

    exportData = () => {


        this.state.exportDataProvider
            .exportData(this.state.dataProvider, this.props.headerComponent.Layout, this.getDataProviderContext);

    };

    onModalChange = (e, { name, value }) => {

       
        if (name === "comments") {
            this.setState({ [name]: value.trim() })
        } else {
            this.setState({ [name]: value })
        }

    }
    handleEnvironmentCommentarySubmit = (e) => {

        const formData = new FormData();

        if (this.state.period === "" || this.state.utility === "" || this.state.comments === "") {

            if (this.state.period === "") {
                this.setState({ isPeriodHasError: true, period: "", });
            } else {
                this.setState({ isPeriodHasError: false });
            }
            if (this.state.utility === "") {
                this.setState({ isUtilityHasError: true, utility: "" });
            } else {
                this.setState({ isUtilityHasError: false });
            }
            if (this.state.comments === "") {
                this.setState({ isCommentsHasError: true, comments: "" });
            } else {
                this.setState({ isCommentsHasError: false, });
            }

            return;
        }
    
        formData.append("siteKey", this.props.dataProvider.apiArgs[1])
        formData.append("fldPeriod", this.state.period);
        formData.append("fldYear", this.state.year);
        formData.append("utility", this.state.utility);
        formData.append("comment", this.state.comments);

        try {
            api.postEnvironmentalCommentary(formData)
                .then(verifyRes => {
                    if (verifyRes === true) {
                        this.setState({

                            commitSuccess: true,
                            open: false,
                            isCommentsHasError: false,
                            isPeriodHasError: false,
                            isUtilityHasError: false
                        });
                        this.notify();
                    }



                })
        } catch (err) {

            
        }
        this.setState({
            period: "",
            utility: "",
            comments: "",
            year: new Date().getFullYear()
        })

    }
    notify = () => {
        toast.success("Successfully saved !", {
            position: toast.POSITION.TOP_CENTER,
            delay: 500
        });
    }
    getYears(yearOptions) {
        const tempYear = this.state.currentYear;
        const minOffset = -10;
        const maxOffset = 10;

        for (let i = minOffset; i <= maxOffset; i++) {
            yearOptions.push({ key: tempYear + i, text: tempYear + i, value: tempYear + i })
        }
        return yearOptions;
    }

    render() {

        const HeaderTag = this.props.headerComponent;
        const RowTag = this.props.rowComponent;
        const rowContent = this.state.data.map((element, index) => (
            <RowTag key={index} data={element} contextData={this.props.contextData} />
        ));

        const PeriodOptions = [
            { key: 'Q1', text: 'Q1', value: 'Q1' },
            { key: 'Q2', text: 'Q2', value: 'Q2' },
            { key: 'Q3', text: 'Q3', value: 'Q3', },
            { key: 'Q4', text: 'Q4', value: 'Q4', }
        ]
        const utilityOptions = [
            { key: 'Gas', text: 'Gas', value: 'Gas' },
            { key: 'Water', text: 'Water', value: 'Water' },
            { key: 'Electricity', text: 'Electricity', value: 'Electricity' },
        ]
        const yearOptions = this.getYears([]);
        return (


            <React.Fragment>
                <div className="data-table">
                    <Dimmer active={this.state.isLoading}>
                        <Loader indeterminate>Refreshing Table</Loader>
                    </Dimmer>
                    <Grid stackable columns='equal'>
                        <Grid.Row>
                            <Grid.Column>
                                {!!this.headerSlot && this.headerSlot.props.children}
                            </Grid.Column>
                            {this.showExport &&
                                <Grid.Column floated='right' width={3}>
                                    <Button compact floated='right' color='orange' onClick={this.exportData}>Export Data</Button>

                                    <Modal
                                        size={'small'}
                                        trigger={<Button compact floated='right' color='orange' >Log Environmental Impact Commentary</Button>}
                                        onClose={() => this.setState({ open: false, isPeriodHasError: false, isUtilityHasError: false, isCommentsHasError: false, period: "", utility: "", comments: "" })}
                                        onOpen={() => this.setState({ open: true })}
                                        open={this.state.open}
                                    >
                                        <Modal.Actions>
                                            <Icon name='close' onClick={() => this.setState({ open: false, isPeriodHasError: false, isUtilityHasError: false, isCommentsHasError: false, period: "", utility: "", comments: "" })} />
                                        </Modal.Actions>
                                        <Modal.Header>
                                            <h3>Log Environmental Impact Commentary</h3>
                                        </Modal.Header>
                                        <Modal.Content>
                                            <Grid columns='three' >

                                                <Grid.Row>
                                                    <Grid.Column>

                                                        Period
                                                        <Dropdown
                                                            placeholder='Please select'
                                                            fluid
                                                            selection
                                                            options={PeriodOptions}
                                                            name="period"
                                                            onChange={this.onModalChange}

                                                            style={this.state.isPeriodHasError ? { border: "1px solid red" } : null}
                                                        />

                                                    </Grid.Column>
                                                    <Grid.Column>

                                                        Year
                                                        <Dropdown
                                                            defaultValue={yearOptions[10].value}
                                                            fluid
                                                            selection
                                                            options={yearOptions}
                                                            name="year"
                                                            onChange={this.onModalChange}
                                                        />

                                                    </Grid.Column>
                                                    <Grid.Column>

                                                        Utility
                                                        <Dropdown
                                                            placeholder='Please select'
                                                            fluid
                                                            selection
                                                            options={utilityOptions}
                                                            name="utility"
                                                            onChange={this.onModalChange}

                                                            style={this.state.isUtilityHasError ? { border: "1px solid red" } : null}
                                                        />

                                                    </Grid.Column>

                                                </Grid.Row>
                                            </Grid>
                                            <Grid>
                                                <Grid.Row>
                                                    <Grid.Column>
                                                        Comments
                                                        <Grid.Column>
                                                            <TextArea
                                                                style={this.state.isCommentsHasError ? { minHeight: 100, minWidth: 650, border: "1px solid red" } : { minHeight: 100, minWidth: 650 }}
                                                                name="comments"
                                                                onChange={this.onModalChange}


                                                            />
                                                        </Grid.Column>
                                                    </Grid.Column>
                                                </Grid.Row>
                                            </Grid>


                                        </Modal.Content>
                                        <Modal.Actions>

                                            <Button color="green" onClick={this.handleEnvironmentCommentarySubmit} >Log Commentary</Button>

                                        </Modal.Actions>

                                    </Modal>


                                </Grid.Column>}
                        </Grid.Row>
                    </Grid>
                    <Table striped padded selectable sortable>
                        <HeaderTag
                            column={this.state.sortSettings.sort}
                            contextData={this.props.contextData}
                            direction={this.state.sortSettings.order}
                            onChangeSort={this.onChangeSort}
                        />
                        <Table.Body>
                            {(this.state.data.length === 0) ? <React.Fragment /> : rowContent}
                        </Table.Body>
                        {!!this.footerSlot && this.footerSlot.props.children}
                    </Table>
                </div>
            </React.Fragment>
        );
    }
}

EnvironmentCommentaryDataTable.propTypes = {
    dataProvider: PropTypes.instanceOf(DataProvider).isRequired,
    headerComponent: PropTypes.elementType.isRequired,
    rowComponent: PropTypes.elementType.isRequired,
    refreshDataTrigger: PropTypes.instanceOf(Observable),
    exportDataProvider: PropTypes.instanceOf(ExportDataProvider),
    onTableRefreshed: PropTypes.func,
    defaultSort: PropTypes.string,
    additionalProviderContext: PropTypes.func,
    name: PropTypes.string,
    canExport: PropTypes.bool,
    contextData: PropTypes.any
};

